import { Container } from "@chakra-ui/react";
import React from "react";
import { EditPeopleModal } from "./components/EditPeopleModal";
import { PeoplesNames } from "./components/PeoplesNames";
import { PixelGrid } from "./components/PixelGrid";

export const App = () => {
  return (
    <Container
      h="100%"
      display="flex"
      justifyContent="center"
      flexDir="column"
      alignItems="center"
      gap={8}
    >
      <EditPeopleModal />
      <PixelGrid />
      <PeoplesNames />
    </Container>
  );
};
